import styled from "@emotion/styled"
import React from "react"
import Button from "../Button/button"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import "./table.scss"

const DynamicTableV2 = props => {
  const T = styled(Table)`
    thead th,
    tbody td {
      width: calc(100% / ${props.rows[0].row.length + 1});
    }

    //TODO: Clean up css
    td {
      &.green,
      &.red,
      &.yellow {
        &:before {
          content: "";
          width: 15px;
          height: 15px;
          border-radius: 50%;
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
        }
      }

      &.green {
        &:after,
        &:before {
          background: #5ead00;
        }
      }

      &.yellow {
        &:after,
        &:before {
          background: #f2b700;
        }
      }

      &.red {
        &:after,
        &:before {
          background: #d32f2f;
        }
      }
    }

    @media screen and (max-width: 991px) {
      td {
        &.green,
        &.red,
        &.yellow {
          &:before {
            display: none;
          }
          &:after {
            content: "";
            width: 15px;
            height: 15px;
            border-radius: 50%;
            display: inline-block;
            vertical-align: middle;
            margin-left: 5px;
          }
        }
      }

      table,
      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      thead th,
      tbody td {
        width: 100%;
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
        border-bottom: 2px solid #333;
      }

      tbody tr {
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        padding: 8px 0;
      }

      td.pivoted {
        padding: 8px 0;
        border: none !important;
        position: relative;
        text-align: left !important;
        white-space: pre-wrap;
        overflow-wrap: break-word;

        &:last-child {
          .tdBefore {
            &:after {
              display: none;
            }
          }
        }
      }

      td .tdBefore {
        display: inline-block;
        left: 1rem;
        white-space: pre-wrap;
        overflow-wrap: break-word;
        text-align: left !important;
        font-weight: 600;
      }
    }

    ${props.rows[0].button
      ? `td {
          padding: 10px 5px;
  
        &:last-child {
          text-align: right;
        }
      }`
      : `td {
        padding: 20px 5px;
      }
    }`}
  `

  return (
    <div className="table">
      <div className="container">
        {props.headline !== "no headline" && (
          <div className="_headline">
            {props.headline_image && (
              <img src={props.headline_image.url} alt="" />
            )}
            {props.headline_image && props.headline_text && (
              <h4 className="_headline-gap">-</h4>
            )}
            {props.headline_text && (
              <h4 className="headline">{props.headline_text}</h4>
            )}
          </div>
        )}
        <T>
          {props.headers.length !== 0 && (
            <Thead>
              <Tr>
                {props.headers.map((header, index) => (
                  <Th key={index}>{header + " "}</Th>
                ))}
                {props.rows[0].row.button && <Th></Th>}
              </Tr>
            </Thead>
          )}
          <Tbody>
            {props.rows.map((row, index) => (
              <Tr key={index}>
                {row.row.map((item, index) =>
                  item.formatted_row_item !== "" ? (
                    <Td
                      key={index}
                      className={
                        item.status_code !== "no status" && item.status_code
                      }
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.formatted_row_item,
                        }}
                      />
                    </Td>
                  ) : (
                    <Td
                      key={index}
                      className={
                        item.status_code !== "no status" && item.status_code
                      }
                    >
                      {item.row_item}
                    </Td>
                  )
                )}
                {row.row.button && (
                  <Td>
                    <Button
                      button_text={row.row.button[0].button_text}
                      button_type={row.row.button[0].button_type}
                      button_color={row.row.button[0].button_color}
                      button_link={row.row.button[0].button_link.href}
                      text_color={row.row.button[0].text_color.href}
                    />
                  </Td>
                )}
              </Tr>
            ))}
          </Tbody>
        </T>
      </div>
    </div>
  )
}

export default DynamicTableV2
